import { render, staticRenderFns } from "./UnsavedTripsContent.vue?vue&type=template&id=a67dbeb6"
import script from "./UnsavedTripsContent.vue?vue&type=script&lang=ts"
export * from "./UnsavedTripsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports